import { render } from "./AlterWall38Component.vue?vue&type=template&id=1a112fcd&scoped=true"
import script from "./AlterWall38Component.vue?vue&type=script&lang=js"
export * from "./AlterWall38Component.vue?vue&type=script&lang=js"

import "./AlterWall38Component.vue?vue&type=style&index=0&id=1a112fcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a112fcd"]])

export default __exports__